<template>
	<div class="omapi-courses__course omapi-omu__grid-item omapi-card__fourth">
		<a :href="url" target="_blank" rel="noopener" @click="maybeUpsell">
			<img v-if="img" :height="img.height" :width="img.width" :src="img.source_url" />
		</a>
		<h4 class="omapi-courses__course-title">
			<!-- eslint-disable-next-line vue/no-v-html -->
			<a :href="url" target="_blank" rel="noopener" @click="maybeUpsell" v-html="course.title" />
		</h4>
		<a
			:href="url"
			target="_blank"
			rel="noopener"
			class="omapi-link-arrow-after omapi-link-underline"
			@click="maybeUpsell"
			>Start Course</a
		>
	</div>
</template>

<script lang="js">
import { debug } from '@/utils';
import { marketingSso } from '@/components/mixins/marketingSso';
import { upsell } from '@/university/mixins/upsell';

export default {
	mixins: [marketingSso, upsell],
	props: {
		course: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			utmMedium: 'UniversityCourse',
		};
	},
	computed: {
		url() {
			return this.marketingUrl(this.course.link, 'University');
		},
		img() {
			let { img } = this.course;

			if (img && debug.enabled('course-media')) {
				img.source_url = img.source_url.replace('optinmonster.test', 'optinmonster.com');
			}

			return img;
		},
	},
};
</script>
